import { Component, Input, OnInit } from "@angular/core";
import { Observable, of } from "rxjs";
import { Survey } from "src/app/shared/Models/read";
import { ToastService } from "src/app/shared/toast.service";
import { DeviceCheckService } from "../../shared/services/device-check.service";
import { OUTSIDE_SURVEY_ADDRESS_INFO } from "../config/outside-survey.magic-strings";
import { Address } from "src/app/shared/Models/Address";
import { SavingStateService } from "../../shared/services/saving-state.service";
import { SaveOutsideSurveyMainAddressDto } from "src/app/shared/Models/write/SaveOutsideSurveyMainAddressDto";
import { AddressTypeEnum } from "src/app/shared/Models/enums/AddressTypeEnum";
import { ValidationError } from "src/app/shared/Models/ValidationError";

@Component({
  selector: "app-outside-survey-address",
  templateUrl: "./outside-survey-address.component.html",
  styleUrls: ["./outside-survey-address.component.scss"],
  providers: [ToastService],
})
export class OutsideSurveyAddressComponent implements OnInit {
  tabId = OUTSIDE_SURVEY_ADDRESS_INFO;
  @Input() survey: Survey;
  @Input() isAuthCanWrite: boolean;
  @Input() isPrefill: boolean;
  mainAddressId: string;
  changed: boolean = false;

  get inPortrait() {
    return this.deviceCheckService.onPortrait();
  }

  get onTablet() {
    return this.deviceCheckService.onTablet();
  }

  get fullName() {
    return [
      this.survey?.outsideEngineer?.firstName,
      this.survey?.outsideEngineer?.lastName,
    ].join(" ");
  }
  constructor(
    private _toastService: ToastService,
    private _savingStateService: SavingStateService,
    private deviceCheckService: DeviceCheckService
  ) {}

  public ngOnInit(): void {
    this.mainAddressId = this.survey.building.addresses.find(
      (a) => a.isMainAddress
    ).id;
  }

  save(checkValidity?: boolean): Observable<any> {
    if (!this.isAuthCanWrite) return of(true);
    if (checkValidity) {
      const valError = this.getValidationError(checkValidity);
      if (valError) {
        this._toastService.showWarnToast(valError.title, valError.message);
        return of(false);
      }
    }
    if (!this.changed) return of(true);
    if (this.isAuthCanWrite) {
      this.changed = false;
      return this._savingStateService.addOutsideSurveyAddress(this.createDto());
    }
  }

  getValidationError(checkValidity?: boolean): ValidationError {
    let valError;
    if (checkValidity)
      if (!this.mainAddressId) {
        valError = new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.address.mainaddress:Building needs a main address`,
          $localize`:@@survey.outside.address.title:Outside Survey, Address`
        );
      } else {
        const mainaddress = this.survey.building.addresses.find(
          (a) => a.id === this.mainAddressId
        );
        const allAddressesNotInUse = this.survey.building.addresses.every(
          (a) => a.addressType === AddressTypeEnum.NotInUse
        );
        if (
          mainaddress.addressType == AddressTypeEnum.NotInUse &&
          !allAddressesNotInUse
        )
          valError = new ValidationError(
            $localize`:@@general.warning:Warning`,
            $localize`:@@validation.survey.address.mainaddressType:Please select a main address of a type other than NotInUse`,
            $localize`:@@survey.outside.address.title:Outside Survey, Address`
          );
      }
    return valError;
  }

  createDto() {
    return new SaveOutsideSurveyMainAddressDto(
      this.survey.id,
      this.survey.building.id,
      this.mainAddressId
    );
  }

  isChanged(): boolean {
    return this.changed;
  }

  onAddressChecked(address: Address) {
    this.changed = true;
    this.mainAddressId = address.id;
    this.survey.building.addresses.forEach(
      (a) => (a.isMainAddress = a.id === address.id)
    );
  }

  canChangeMainAddress(address: Address) {
    return (
      this.mainAddressId !== address.id &&
      this.isAuthCanWrite &&
      this.checkAddressInUse(address)
    );
  }

  public checkAddressInUse(address: Address) {
    return address.addressType !== AddressTypeEnum.NotInUse;
  }
}
